import { useTranslation } from "react-i18next";

import { Form, Header, Message, TextArea } from "simplydo/react/ui";

import { MultiLineParagraph } from "components/lib/UI";

import { FieldProps } from "./FieldProps";

const AssessmentFeedback = ({
  field,
  fieldValue = "",
  updateIdea,
  isEditing,
}: FieldProps) => {
  const { t } = useTranslation();
  const textValue = typeof fieldValue === "string" ? fieldValue : "";

  if (!isEditing) {
    return (
      <>
        <Header size="tiny">Feedback</Header>
        <MultiLineParagraph content={textValue} />
      </>
    );
  }

  return (
    <Form>
      <Message size="small">
        The contents of this field will be used by the {t("generic.challenge")}{" "}
        manager to provide direct feedback to the {t("generic.idea")} author.
      </Message>
      <TextArea
        defaultValue={textValue}
        placeholder={`Enter feedback to the ${t("generic.idea")} author...`}
        onChange={(_e, { value }) =>
          updateIdea(String(value ?? ""), ["templated", field.id])
        }
      />
    </Form>
  );
};

export default AssessmentFeedback;
